import { SelectItem } from 'primeng/api';
import { Component, OnInit, ViewChildren, QueryList, ViewChild, Input } from '@angular/core';
import { MenuServiceInt } from '@core/_services/menu.serviceint';
import { MessagesService } from '@core/_services/messages.service';
import { Table } from 'primeng/table';
import { TabPanelHandler } from '@core/_utils/table.utils';
import { getUserListData } from '@core/_utils/tools.utils';
import { CommonService } from '@service/common.service';
import { dateFormat, formatDateInt } from '@core/_utils/date.utils';
import { RequestTools } from '@service/request.tools';
import { AuthService } from '@auth/auth.service';
import { CheckTools } from '@service/check.tools';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-list-delegate',
    templateUrl: './list-delegate.component.html',
    styleUrls: ['./list-delegate.component.scss'],
})
export class ListDelegateComponent extends TabPanelHandler implements OnInit {
    public value = true;
    public results = [];
    public userList = [];
    public fromUser = [];
    public toUser = [];
    public delegateList = [];
    public delegate: any;
    public userInfo: string = '';
    public isAdmin = false;
    public stateList: SelectItem[];
    public activList: SelectItem[];
    protected _isInRangeTimeout: any;

    public listColumns = [];

    @ViewChildren('p-tabPanel:not(:first-child)')
    public itemChildren: QueryList<any>;

    @ViewChild('dt')
    public dataTable: Table;
    public blockEvent = false;

    @Input()
    public entities: Array<any> = [];

    constructor(
        private checkTools: CheckTools,
        public menu: MenuServiceInt,
        private auth: AuthService,
        protected _messageService: MessagesService,
        private commonService: CommonService,
        private requestTools: RequestTools,
        protected translate: TranslateService
    ) {
        super(translate);
        this.menu.display = true;
        this.isAdmin = this.auth.isAdmin();
    }

    ngOnInit() {
        this.listColumns = [
            { header: this.translate.instant('Activ'), field: 'UseDelegate' },
            { header: this.translate.instant('State'), field: 'inProgress' },
            { header: this.translate.instant('&doc_owner'), field: 'UserLogin' },
            { header: this.translate.instant('Date_Beg'), field: 'DateBeginDis' },
            { header: this.translate.instant('Date_End'), field: 'DateEndDis' },
            { header: this.translate.instant('Delegate_2'), field: 'UserDelegated' },
        ];

        this.activList = [
            { label: this.translate.instant('All'), value: null },
            { label: this.translate.instant('Activ_1'), value: 'true' },
            { label: this.translate.instant('NoActiv'), value: 'false' },
        ];
        this.stateList = [
            { label: this.translate.instant('All'), value: null },
            { label: this.translate.instant('Prog_In_1'), value: true },
            { label: this.translate.instant('Prog_In_C'), value: false },
        ];

        this.findAll();
        this.commonService.checkReset();
    }

    setFilteredList(event) {}

    private async findAll() { 
        this.delegateList = [];
        this.userList = [];
        this.fromUser = [];
        this.toUser = [];
        let wRes: any;

        wRes = await this.requestTools.readDelegate();
        this.checkTools.checkError(wRes);
        if (this.checkTools.getRes() === false) {
            this._messageService.addErrorMsg(this.checkTools.getMsg());
            return;
        }

        // liste utilisateurs issus des droits à déléguer (tableau de login)
        this.delegateList = this.setDataDelegate(wRes.data);

        // liste des délégations issus du ConfigServer
        this.results = this.setDataResultList(wRes.data.getResultList);
               
        if (this.userInfo === 'grp') {
            this.delegateList = await this.getDelegateListFromGroups(this.delegateList);   
        }

        // liste de tous les utilisateurs : tableau label, value)
        this.userList = this.setDataUserList(wRes.data.getUserList);

        // Liste fromUser
        this.setAllArray();

         // Liste toUser
        this.toUser = await this.getToUser(wRes.data);
    }

    private async getToUser(aData) {
        let wArray = [];
        // Tous les utilisateurs
        if (aData.getDelegateListUser.data.length === 0 || this.isAdmin === true) {
            wArray = this.userList;
        } else {
            if (aData.getDelegateListUser.data[0].visibilityto === 0 || aData.getDelegateListUser.data[0].visibilityto === null) {
                wArray = this.userList;
            } else {
                // Récupération de la liste : groupe ou user
                wArray = this.getToList(aData.getDelegateListUser.data[0].webDelegaterightVisibilities, 1);
                // Liste de groupe
                if (aData.getDelegateListUser.data[0].visibilityto === 1 ) {
                    // Récupération liste utilisateurs des groupes
                    wArray = await this.getDelegateListFromGroups(wArray);
                }
                wArray = this.setGenericList(this.userList, wArray, 'value');
            }
        }
        return wArray;
    }


    private setGenericList(aFilterList, aTargetList, aKey) {
        let wArray = [];
        wArray = aFilterList.filter((item) => {
            if (this.inList(item[aKey], aTargetList) === true) {
                return item;
            }
        })   
        return wArray;
    }

    private async getDelegateListFromGroups(aDelegateList) {
        let wData: any;
        let wArray = [];
        wData = {
            datarequest: aDelegateList.toString()
        };
        // liste utilisateurs issus des droits à déléguer
        wArray = await this.readGroup(wData);          
        return wArray;
    }

    private setAllArray() {
        // maj des résultats issus du ConfigServer / aux utilisateurs pouvant déléguer
        this.results = this.setGenericList(this.results, this.delegateList, 'FromLogin');
        // liste des utilisateurs pouvant déléguer et qui n'ont pas déjà une délégation
        this.fromUser = this.setGenericList(this.userList, this.delegateList, 'value');
        this.fromUser = this.getFromUser();
    }

    private inList(aValue, aList) {
        let wRes: any;
        wRes = aList.filter((item) => {
            return item === aValue
        })
        return (wRes.length !== 0);
    }

    private getFromUser() {
        let wArray = [];
        wArray = this.fromUser.filter((item) => {
            if (this.isInList(item.value, this.results) === false) {
                return item;
            }
        })
        return wArray;
    }

    private isInList(aValue, aList) {
        let wRes: any;        
        wRes = aList.filter((item) => {
            return item.FromLogin === aValue
        })
        return (wRes.length !== 0);
    }

    private getToList(aData, aVisibilitytype) {
        let wArray = [];
        aData.map((item) => {
            if (item.visibilitytype === aVisibilitytype) {
                wArray.push(item.name)
            }
        })
        return wArray
    }

    private async readGroup(aData) {
        let wRes: any;
        let wArray = [];
        wRes = await this.requestTools.readGroup(aData);
        if (this.verifyStatus(wRes.Status) === false) {
            return [];
        }
        wRes.data.UserList.User.map((item) => {
            wArray.push(item.Information.Login);
        })
        return wArray;
    }

    private setDataDelegate(aData) {
        let wArray = [];
        if (this.verifyStatus(aData.getDelegateListUser.Status) === false) {
            return wArray;  
        } else {
            this.userInfo = 'all';
            // tableau vide : tous les utilisateurs           
            if (this.isAdmin === false) {
                if (aData.getDelegateListUser.data.length !== 0) {
                    if (aData.getDelegateListUser.data[0].visibility === 2) {
                        // utilisateurs 
                        this.userInfo = 'user';
                        this.addDelegateUser(wArray, aData.getDelegateListUser.data[0].webDelegaterightVisibilities);
                    } else {
                        // groupes
                        this.userInfo = 'grp';
                        this.addDelegate(wArray, aData.getDelegateListUser.data[0].webDelegaterightVisibilities);
                    }
                } else {
                    // tous les utilisateurs
                    this.userInfo = 'all';
                    aData.getUserList.UserList.User.map((item) => {
                        wArray.push(item.Information.Login);
                    })
                }
            } else {
                // admin tous les utilisateurs
                this.userInfo = 'all';
                aData.getUserList.UserList.User.map((item) => {
                    wArray.push(item.Information.Login);
                })
            }
            return wArray;
        }
    }

    private addDelegate(aArray, aData) {
        aData.map((item) => {
            if (item.visibilitytype === 0) {
                aArray.push('"'+item.name+'"');
            }
        })
    }

    private addDelegateUser(aArray, aData) {
        aData.map((item) => {
            if (item.visibilitytype === 0) {
                aArray.push(item.name);
            }
        })
    }

    private setDataResultList(aData) {
        if (this.verifyStatus(aData.Status) === false) {
            return [];     
        } else {
            return this.formatResult(aData.UserList.Delegate);
        }
    }

    private setDataUserList(aData) {
        if (this.verifyStatus(aData.Status) === false) {
            return [];        
        } else {
            return getUserListData(aData.UserList);
        }
    }

    private verifyStatus(aStatus) {
        if (aStatus !== 'OK') {
            this._messageService.addErrorMsg(this.translate.instant('Load_Data_KO'));
            return false;
        } else {
            return true;
        }        
    }
    
    private formatResult(aList) {
        let wIdx: number = 0;
        let wTab = [];
        wTab = aList.map((item) => {
            item.id = wIdx;
            item.name = item.UserLogin;
            item.label = item.UserLogin;
            item.value = item.UserLogin;
            item._label = item.UserLogin;
            item.reference = item.UserLogin;
            item.DateBeginDis = item.DateBegin + '|' + dateFormat(item.DateBegin, 'dd/MM/yyyy');
            item.DateEndDis = item.DateEnd + '|' + dateFormat(item.DateEnd, 'dd/MM/yyyy');
            item.inProgress = this.getInProgress(item.DateBegin, item.DateEnd);
            wIdx++;
            return item;
        });
        return wTab;
    }

    private getInProgress(aBegin, aEnd) {
        let wDateBegin: Date;
        let wDateEnd: Date;
        let wDateNow: Date;
        wDateBegin = new Date(formatDateInt(new Date(aBegin), false));
        wDateEnd = new Date(formatDateInt(new Date(aEnd), true));
        wDateNow = new Date();
        if ( ( wDateBegin <= wDateNow ) && ( wDateNow <= wDateEnd ) ) {
            return true;
        } else {
            return false;
        }
    }

    closeTab(event) {
        this.closeTabsheet(event);
        this.index = event.index - 1;
        this.execClose(event);
    }


    validateTab(event) {
        this.results = this.formatResult(event.data.Delegate);
        this.setAllArray();
        this.closeTab(event);
    }

    addTab(event) {
        this.results = this.formatResult(event.data.Delegate);
        this.setAllArray();
        this.closeTabsheet(this._event);
        this.index = this.index - 1;
    }

    deleteTab(event) {
        this.results = this.results.filter((item) => {
            return item.id !== event.data.id;
        });
        this.results = [...this.results];
        this.closeTab(event);
    }

    cancelAdd(event) {
        this.closeTabsheet(this._event);
        this.index = this.index - 1;
    }

    handleChange($event) {
        this.index = $event.index;
    }

    showDetails(item) {
        this.delegate = item.data;
        item = item.data;
        if (!this.isAlreadySelected(item.id)) {
            this.addElement(item.id, item.name, item.name);
        }
    }

    sortReference(event: any): void {}
}
